import { FiltersSectionOrder } from '@bridebook/web/app-shared/lib/search/types';

const sectionOrderBlueprint: FiltersSectionOrder = {
  priceSection: [],
  guestsSection: [],
  distanceSection: [],
  overviewSection: [],
  accommodationRoomsSection: [],
  venueType: [],
  venueStyle: [],
  venueFeatures: [],
  foodDrinkSection: [],
  specialOffers: [],
  upcomingEvents: [],
  specialistWeddingSection: [],
  diversityAndInclusion: [],
};

const sectionOrder: FiltersSectionOrder = {
  ...sectionOrderBlueprint,
  priceSection: ['hasQualityPricing'],
  guestsSection: ['guests'],
  distanceSection: ['radiusIncrease'],
  overviewSection: [
    'bestOfBritain',
    'highestReviewed',
    'exclusiveUse',
    'weddingLicence',
    'hasAccommodation',
    'lateNightExtensionAvailable',
    'alcoholLicense',
  ],
  accommodationRoomsSection: ['upTo10', 'rooms10', 'rooms20', 'rooms30', 'rooms50'],
  venueType: [
    'countryHouseManorHouse',
    'barn',
    'gardenOutdoor',
    'statelyHome',
    'castle',
    'hotel',
    'cityHotelCityVenue',
    'warehouseFactory',
    'museumAttraction',
    'uniqueVenueType',
    'pubRestaurant',
    'golfCourse',
    'cruiseBoatYacht',
    'sportingVenueStadium',
    'conferenceCentre',
    'placeOfWorship',
    'townHallRegistryOffice',
    'otherVenueType',
  ],
  venueStyle: [
    'classic',
    'intimate',
    'alternative',
    'romantic',
    'lovelyGrounds',
    'unusual',
    'affordable',
    'outdoor',
    'luxury',
    'rustic',
    'beach',
    'modern',
    'unique',
    'urban',
    'blankCanvas',
    'greatViews',
    'historic',
    'asian',
    'casual',
    'formal',
    'stylish',
  ],
  venueFeatures: [
    'onsiteParking',
    'disabledAccess',
    'inHouseWeddingCoordinator',
    'inHouseDancefloor',
    'soundSystemAvailable',
    'ballroom',
    'confettiPermitted',
    'fireworksPermitted',
    'marqueePermitted',
    'waterView',
    'landscapedGardens',
    'petFriendly',
    'churchWithinWalkingDistance',
  ],
  foodDrinkSection: [
    'inHouseCatering',
    'externalCateringPermitted',
    'kosherCatering',
    'halalCatering',
    'asianCatering',
    'byobPermitted',
    'vegan',
  ],
  specialOffers: ['hasDiscounts', 'hasBridebookOffer', 'hasGift', 'hasLateAvailability'],
  upcomingEvents: ['hasWeddingFair', 'hasShowroundViewingDatesAvailable'],

  specialistWeddingSection: [
    'asianWeddingSpecialist',
    'jewishWeddingSpecialist',
    'muslimWeddingSpecialist',
    'otherWeddingSpecialist',
  ],
  diversityAndInclusion: ['inclusivityLgbtqPlusExpert', 'inclusivityNeurodiverseFriendly'],
};

const sectionOrderUS: FiltersSectionOrder = {
  ...sectionOrderBlueprint,
  priceSection: sectionOrder.priceSection,
  guestsSection: sectionOrder.guestsSection,
  distanceSection: sectionOrder.distanceSection,
  overviewSection: ['hasAccommodation', 'alcoholLicense'],
  accommodationRoomsSection: sectionOrder.accommodationRoomsSection,
  venueType: [
    'barn',
    'conferenceCentre',
    'countryHouseManorHouse',
    'cruiseBoatYacht',
    'gardenOutdoor',
    'golfCourse',
    'hotel',
    'museumAttraction',
    'placeOfWorship',
    'pubRestaurant',
    'rooftop',
    'winery',
  ],
  venueFeatures: ['disabledAccess', 'onsiteParking', 'transportation', 'wifi', 'petFriendly'],
  foodDrinkSection: ['inHouseCatering', 'externalCateringPermitted', 'bar'],
};

const sectionOrderDE: FiltersSectionOrder = {
  ...sectionOrderBlueprint,
  priceSection: sectionOrder.priceSection,
  guestsSection: sectionOrder.guestsSection,
  distanceSection: sectionOrder.distanceSection,
  overviewSection: ['highestReviewed', 'exclusiveUse', 'hasAccommodation', 'alcoholLicense'],
  accommodationRoomsSection: sectionOrder.accommodationRoomsSection,
  venueType: [
    'countryHouseManorHouse',
    'barn',
    'gardenOutdoor',
    'statelyHome',
    'castle',
    'hotel',
    'cityHotelCityVenue',
    'warehouseFactory',
    'museumAttraction',
    'pubRestaurant',
    'golfCourse',
    'cruiseBoatYacht',
    'sportingVenueStadium',
    'conferenceCentre',
    'placeOfWorship',
    'townHallRegistryOffice',
    'otherVenueType',
    'rooftop',
    'winery',
  ],
  venueStyle: [
    'classic',
    'intimate',
    'alternative',
    'romantic',
    'lovelyGrounds',
    'unusual',
    'affordable',
    'outdoor',
    'luxury',
    'rustic',
    'beach',
    'modern',
    'unique',
    'urban',
    'blankCanvas',
    'greatViews',
    'historic',
    'asian',
    'casual',
    'formal',
    'stylish',
  ],
  venueFeatures: [
    'onsiteParking',
    'disabledAccess',
    'inHouseWeddingCoordinator',
    'inHouseDancefloor',
    'soundSystemAvailable',
    'ballroom',
    'confettiPermitted',
    'fireworksPermitted',
    'marqueePermitted',
    'waterView',
    'landscapedGardens',
    'petFriendly',
    'churchWithinWalkingDistance',
  ],
  foodDrinkSection: ['inHouseCatering', 'externalCateringPermitted', 'byobPermitted', 'vegan'],
  specialOffers: ['hasLateAvailability'],
  upcomingEvents: sectionOrder.upcomingEvents,
  specialistWeddingSection: [
    'asianWeddingSpecialist',
    'jewishWeddingSpecialist',
    'muslimWeddingSpecialist',
    'otherWeddingSpecialist',
  ],
  diversityAndInclusion: sectionOrder.diversityAndInclusion,
};

const sectionOrderFR: FiltersSectionOrder = {
  ...sectionOrderBlueprint,
  priceSection: sectionOrder.priceSection,
  guestsSection: sectionOrder.guestsSection,
  distanceSection: sectionOrder.distanceSection,
  overviewSection: [
    'highestReviewed',
    'exclusiveUse',
    'hasAccommodation',
    'lateNightExtensionAvailable',
  ],
  accommodationRoomsSection: sectionOrder.accommodationRoomsSection,
  venueType: [...sectionOrder.venueType, 'rooftop', 'winery'],
  venueStyle: sectionOrder.venueStyle,
  venueFeatures: sectionOrder.venueFeatures,
  foodDrinkSection: sectionOrder.foodDrinkSection,
  specialOffers: ['hasDiscounts', 'hasBridebookOffer', 'hasGift', 'hasLateAvailability'],
  upcomingEvents: sectionOrder.upcomingEvents,
  specialistWeddingSection: sectionOrder.specialistWeddingSection,
  diversityAndInclusion: sectionOrder.diversityAndInclusion,
};

const sectionOrderIE: FiltersSectionOrder = { ...sectionOrder };

const sectionOrderBBGlobal: FiltersSectionOrder = {
  ...sectionOrderBlueprint,
  priceSection: sectionOrder.priceSection,
  guestsSection: sectionOrder.guestsSection,
  distanceSection: sectionOrder.distanceSection,
  accommodationRoomsSection: sectionOrder.accommodationRoomsSection,
  venueType: [
    'resort',
    'countryHouseManorHouse',
    'castle',
    'barn',
    'conferenceCentre',
    'pubRestaurant',
    'hotel',
    'cruiseBoatYacht',
    'gardenOutdoor',
    'golfCourse',
    'placeOfWorship',
    'uniqueVenueType',
  ],
  venueStyle: sectionOrder.venueStyle,
  venueFeatures: ['disabledAccess', 'onsiteParking', 'petFriendly'],
};

const sectionOrderAT: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

const sectionOrderAU: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

const sectionOrderCA: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

const sectionOrderCH: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

const sectionOrderZA: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

const sectionOrderIT: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

const sectionOrderES: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

const sectionOrderNZ: FiltersSectionOrder = {
  ...sectionOrderBBGlobal,
  upcomingEvents: sectionOrder.upcomingEvents,
  venueType: [...sectionOrder.venueType, 'winery'],
  specialOffers: ['hasLateAvailability'],
};

export {
  sectionOrder,
  sectionOrderUS,
  sectionOrderDE,
  sectionOrderFR,
  sectionOrderIE,
  sectionOrderBBGlobal,
  sectionOrderAT,
  sectionOrderAU,
  sectionOrderCA,
  sectionOrderCH,
  sectionOrderZA,
  sectionOrderIT,
  sectionOrderES,
  sectionOrderNZ,
};
